import { Tbody, Tr } from '@chakra-ui/react';
import { Table, TableDataCell, TableHead, TableHeadingCell } from './table';

type TableRow = {
  cells: Array<string | React.ReactNode>;
};

export function Tables({
  headings,
  rows
}: {
  headings: Array<string>;
  rows: TableRow[];
}) {
  return (
    <Table>
      <TableHead>
        <Tr>
          {headings?.map((heading, index) => {
            return (
              <TableHeadingCell key={`th-${index}`}>{heading}</TableHeadingCell>
            );
          })}
        </Tr>
      </TableHead>
      <Tbody>
        {rows.map((row, index) => (
          <Tr key={`row-${index}`}>
            {row.cells.map((cell, idx) => {
              const result =
                typeof cell === 'string' ? cell.split(/\r?\n/) : [];

              if (result.length > 1) {
                return (
                  <TableDataCell key={`cell-${index}-${idx}`}>
                    {result.map((line, i) => (
                      <span key={`line-${i}`}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </TableDataCell>
                );
              }

              return (
                <TableDataCell key={`cell-${index}-${idx}`}>
                  {cell}
                </TableDataCell>
              );
            })}
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
